export const callAll =
  (...fns: (((...args: any) => any) | undefined)[]) =>
  (...args: any): void =>
    fns.forEach((fn) => fn?.(...args));

export const wait = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
